import React from 'react';

interface IProps {
  title: string;
  content: React.ReactNode | string;
}

const TitleContent = (props: IProps) => {
  return (
    <>
      <div
        style={{
          color: 'rgba(255, 255, 255, 0.6)',
          fontSize: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        {props.title}
      </div>
      <div
        style={{
          fontSize: '11px',
          width: '100%',
          overflowWrap: 'break-word',
          whiteSpace: 'pre-wrap',
        }}
      >
        {props.content}
      </div>
    </>
  );
};

export default TitleContent;
